import { render, staticRenderFns } from "./StockingMirror.vue?vue&type=template&id=354d8b1e&scoped=true"
import script from "./StockingMirror.vue?vue&type=script&lang=js"
export * from "./StockingMirror.vue?vue&type=script&lang=js"
import style0 from "./StockingMirror.vue?vue&type=style&index=0&id=354d8b1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354d8b1e",
  null
  
)

export default component.exports